import { makeAutoObservable } from "mobx";
import { organizationalStructureAPI } from "../../OrganizationalStructure/organizationalStructureAPI";

class OrganizationalStructureStore {
  ////////選擇的頁面
  selectedOSPage = 0;

  ////////companyList loading
  companyListLoading = false;
  //loading
  organizationListLoading = false;
  ////////userManagement loading
  userManagementLoading = false;

  ////////companyList data
  companyListData = {
    fullList: [],
    page: 1,
    pageSize: 10,
  };

  //////// organizationList data
  organizationListData = [];

  //////////userManagement data
  userManagementListData = {
    fullList: [],
    page: 1,
    pageSize: 10,
  };

  //////////是否開啟編輯公司的modal
  isShowEditCompanyModal = false;

  //////////是否開啟編輯帳號superAdmin的modal
  isShowEditSuperAdminModal = false;

  //////////是否開啟新增或編輯帳號Admin和Operator的modal
  isShowOrgUserModal = false;
  orgUserModalType = "";

  //////////是否開啟忘記密碼的modal
  isShowChangePasswordModal = false;
  changePasswordModalType = "";

  //////////是否新增分類的modal
  isShowAddCategoryModal = false;

  //////////是否刪除分類的modal
  isShowDeleteCategoryModal = false;

  //////////是否刪除角色的modal
  isShowDeleteUserModal = false;

  //////////是否編輯分類層級的modal
  isShowEditCategoryDepthModal = false;
  categoryModalType = "";

  //////////是否編輯公司層級的modal
  isShowEditCompanyDepthModal = false;

  //////////被選擇的公司
  selectedCompanyInfo = {
    id: 0,
    name: "",
    country: "",
    address: "",
    type: "",
    orgId: "", //上層公司
    groupEFId: "",
    effectiveDate: "",
    expiryDate: "",
    parentId: "",
    parentName: "",
    hasChild: false,
  };

  //////////被選擇的節點
  selectedNodeInfo = {
    id: 0,
    name: "",
    parentId: "",
  };
  ////////////可以選擇的分類
  categoryOptions = [];

  /////頁碼
  currentListPage = 1;
  ////////總共的頁碼
  totalPage = 0;

  //////////被選擇的user
  selectedOrgUserInfo = {
    id: 0,
    userId: "",
    userName: "",
    roleName: "",
    email: "",
    companyName: "",
    isEdit: "",
    companyId: "",
  };

  //配色用
  selectedColor = 0;

  /////重置公司modal
  isShowResetCompanyModal = false;

  //確認是否切換使用者架構的modal
  isShowConfirmSwitchModeModal = false;

  isShowOrgUserExcelModal = false;
  isOrgUserExcelModalLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  ////////更新選擇的EF頁面
  _handleSetOSPage = (value) => {
    this.selectedOSPage = value;
  };

  ////////開啟或關閉編輯公司modal
  _handleSetIsShowEditCompanyModal = (value) => {
    this.isShowEditCompanyModal = value;
  };

  ////////開啟或關閉編輯super admin帳號modal
  _handleSetIsShowEditSuperAdminModal = (value) => {
    this.isShowEditSuperAdminModal = value;
  };

  ////////開啟或關閉新增/編輯帳號modal
  _handleSetIsShowOrgUserModal = (type, value) => {
    this.orgUserModalType = type;
    this.isShowOrgUserModal = value;
  };

  ////////開啟或關閉忘記密碼modal
  _handleSetIsShowChangePasswordModal = (type, value) => {
    this.changePasswordModalType = type;
    this.isShowChangePasswordModal = value;
  };

  ////////開啟或關閉新增分類的modal
  _handleSetIsShowAddCategoryModal = (value) => {
    this.isShowAddCategoryModal = value;
  };

  ////////開啟或關閉刪除角色的modal
  _handleSetIsShowDeleteUserModal = (value) => {
    this.isShowDeleteUserModal = value;
  };

  ////////開啟或關閉是否刪除分類的modal
  _handleSetIsShowDeleteCategoryModal = (value) => {
    this.isShowDeleteCategoryModal = value;
  };

  ////////開啟或關閉是否編輯分類層級的modal
  _handleSetIsShowEditCategoryDepthModal = (type, value) => {
    this.categoryModalType = type;
    this.isShowEditCategoryDepthModal = value;
  };

  ////////開啟或關閉是否編輯公司層級的modal
  _handleSetIsShowEditCompanyDepthModal = (value) => {
    this.isShowEditCompanyDepthModal = value;
  };

  ////////設定companyListData
  _handleSetCompanyListData = (key, data) => {
    this.companyListData[key] = data;
  };

  ////開啟或關閉user匯入匯出modal
  _handleSetIsShowOrgUserExcelModal = (value) => {
    this.isShowOrgUserExcelModal = value;
  };

  ////////匯入匯出視窗是否有loading
  _handleSetOrgUserExcelModalLoading = (value) => {
    this.isOrgUserExcelModalLoading = value;
  };

  ////////計算CompanyList的目前頁面資料
  get companyListCurrentPageList() {
    const { fullList, page, pageSize } = this.companyListData;
    return fullList.slice((page - 1) * pageSize, page * pageSize);
  }
  ////////company Loading狀態
  _handleSetCompanyListLoading(value) {
    this.companyListLoading = value;
  }

  ////////設定userManagementData
  _handleSetUserManagementListData = (key, data) => {
    this.userManagementListData[key] = data;
    console.log(this.userManagementListData[key]);
  };

  ////////計算UserManagement的目前頁面資料
  get userManagementCurrentPageList() {
    const { fullList, page, pageSize } = this.userManagementListData;
    return fullList.slice((page - 1) * pageSize, page * pageSize);
  }

  ////////userManagement Loading狀態
  _handleSetUserManagementLoading(value) {
    this.userManagementLoading = value;
  }

  ////////設定OrganizationListData
  _handleSetOrganizationListData(data) {
    this.organizationListData = data;
  }
  ////////organization Loading狀態
  _handleSetOrganizationListLoading(value) {
    this.organizationListLoading = value;
  }

  //////設定給selectedCompanyInfo
  _handleSetSelectedCompanyInfo(
    id,
    name,
    country,
    address,
    type,
    rootId,
    groupEFId,
    effectiveDate,
    expiryDate,
    parentId,
    parentName,
    hasChild,
  ) {
    this.selectedCompanyInfo.id = id;
    this.selectedCompanyInfo.name = name;
    this.selectedCompanyInfo.country = country;
    this.selectedCompanyInfo.address = address;
    this.selectedCompanyInfo.type = type;
    this.selectedCompanyInfo.rootId = rootId;
    this.selectedCompanyInfo.groupEFId = groupEFId;
    this.selectedCompanyInfo.effectiveDate = effectiveDate;
    this.selectedCompanyInfo.expiryDate = expiryDate;
    this.selectedCompanyInfo.parentId = parentId;
    this.selectedCompanyInfo.parentName = parentName;
    this.selectedCompanyInfo.hasChild = hasChild;
    console.log(
      "this.selectedCompanyInfohasChild",
      this.selectedCompanyInfo.hasChild,
    );
  }
  //被選擇節點的id
  _handleSetSelectedNodeInfo(id, name, parentId) {
    this.selectedNodeInfo.id = id;
    this.selectedNodeInfo.name = name;
    this.selectedNodeInfo.parentId = parentId;
  }

  /////設定可以選擇category選項
  _handleSetCategoryOptions(data) {
    this.categoryOptions = data;
    console.log("this.categoryOptions", this.categoryOptions);
  }

  //設定給selectOrgUserInfo
  _handleSetSelectedOrgUserInfo(
    id,
    userId,
    userName,
    roleName,
    email,
    companyName,
    isEdit,
    companyId,
  ) {
    this.selectedOrgUserInfo.id = id;
    this.selectedOrgUserInfo.userId = userId;
    this.selectedOrgUserInfo.userName = userName;
    this.selectedOrgUserInfo.roleName = roleName;
    this.selectedOrgUserInfo.email = email;
    this.selectedOrgUserInfo.companyName = companyName;
    this.selectedOrgUserInfo.isEdit = isEdit;
    this.selectedOrgUserInfo.companyId = companyId;
    console.log("this.selectedOrgUserInfo", this.selectedOrgUserInfo);
  }

  //刪除給UserInfo
  _handleSetSelectedDelUserInfo(id, userId, userName) {
    this.selectedOrgUserInfo.id = id;
    this.selectedOrgUserInfo.userId = userId;
    this.selectedOrgUserInfo.userName = userName;
  }

  //更新配色
  _handleSetColor = (value) => {
    this.selectedColor = value;
  };

  ////////開啟或關閉重置公司的modal
  _handleSetIsShowResetCompanyModal = (value) => {
    this.isShowResetCompanyModal = value;
  };

  //get list
  getCompanyList = async (userId, preservePage = false) => {
    this._handleSetCompanyListLoading(true);
    ////////清空list資料讓切換tab不要留存上一次的資料
    this._handleSetCompanyListData("fullList", []);
    if (!preservePage) {
      this._handleSetCompanyListData("page", 1);
    }

    try {
      //去呼叫後端API
      const data = await organizationalStructureAPI.getCompanyListAPI(userId);
      console.log("拿到的company列表是：", data);
      this._handleSetCompanyListData("fullList", data);
      // console.log("length", data.length);
    } catch (error) {
      console.error("Error fetching data entry list", error);
      this._handleSetCompanyListData("fullList", []);
    } finally {
      this._handleSetCompanyListLoading(false);
    }
  };

  //get list
  getOrgUserList = async (userId) => {
    this._handleSetUserManagementLoading(true);
    ////////清空list資料讓切換tab不要留存上一次的資料
    this._handleSetUserManagementListData("fullList", []);
    this._handleSetUserManagementListData("page", 1);
    try {
      //去呼叫後端API
      const data = await organizationalStructureAPI.getOrgUserListAPI(userId);
      console.log("拿到的列表是：", data);
      //先排superadmin在排senior admin，其他角色不排序
      const roleOrder = { superAdmin: 0, seniorAdmin: 1 };
      const sortedData = [...data].sort((a, b) => {
        const orderA = roleOrder[a.roleName] ?? Infinity;
        const orderB = roleOrder[b.roleName] ?? Infinity;
        return orderA - orderB;
      });
      this._handleSetUserManagementListData("fullList", sortedData);
    } catch (error) {
      console.error("Error fetching list", error);
      this._handleSetUserManagementListData("fullList", []);
    } finally {
      this._handleSetUserManagementLoading(false);
    }
  };

  //開啟或關閉切換使用者架構的modal
  _handleSetIsShowConfirmSwitchModeModal = (value) => {
    this.isShowConfirmSwitchModeModal = value;
  };

  //downloadUserExcel
  downloadUserExcel = async (rootId, lang) => {
    this._handleSetOrgUserExcelModalLoading(true);
    try {
      await organizationalStructureAPI.downloadUserListExcel(rootId, lang);
      return true;
    } catch (error) {
      console.error("Error downloading user list excel", error);
      return null;
    } finally {
      this._handleSetOrgUserExcelModalLoading(false);
    }
  };

  //UploadUserExcel
  uploadUserExcel = async (file, rootId) => {
    try {
      const result = await organizationalStructureAPI.uploadUserListExcel(
        rootId,
        file,
      );
      return result;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  //更改使用者架構
  setUserStructureMode = async (type, rootId) => {
    try {
      const data = await organizationalStructureAPI.setUserStructureMode(
        type,
        rootId,
      );
      if (data) {
        console.log("拿到的列表是：", data);
      }
    } catch (err) {
      console.error(err);
      return null;
    }
  };
}
const organizationalStructureStore = new OrganizationalStructureStore();
export default organizationalStructureStore;
